import * as React from "react";
import { useModules } from '../../utils/modules';
import { useState, useRef, useEffect } from "react";
import {
    IMAGE_BASE_PATH,
    CharConstants,
    StringConstants,
    WorkkardActions,
    MAX_UPLOAD_FILE_SIZE,
    INVALID_FILES_TO_UPLOAD,
    FILE_UPLOAD_URL,
    ADD_NOTE_ERROR_MESSAGE,
    DATE_FORMAT
} from '../../containers/WorkkardDetail/constants';
import { DEFAULT_DATE_FORMAT, TEMPLATE_VALUES, VALIDATE_SPECIAL_CHAR_FIELD_ARRAY, SPECIAL_CHAR_VALIDATION_MSG, LICENSE_NUMERIC_VALIDATION_MSG } from '../../common/constants';
import { connect, useSelector } from "react-redux";
import { bindActionCreators } from "redux";
import CKTextEditor from "../CKTextEditor";
import Icon from '../../icons';
import * as CommonUtil from '../../common/util';
import { showDialogueBox, hideDialogueBox } from '..//DialogueBox/actions';
import ConfirmationTextBox from "../ConfirmationPrompt";
import FieldRenderingEngine from "../FieldRenderingEngine";
import PublicApiExzeoUpload from '../PublicApiExzeoUpload';
import { saveAndUpdateFileCaption, resetAttachedWorkkardFiles, resetAttachedWorkkardLetters, setPanelVisibility, getTimezoneByZip, resetPostApiActionError } from '../../containers/WorkkardDetail/actions/action';
import AttachedWorkkardFiles from '../AttachedWorkkardFIles';
import AttachedWorkkardLetters from '../AttachedWorkkardLetters';
import DropZone from './dropZone';
import { hideRightPopUpBox } from "../RightPopUpComponent/actions";
import LoaderComponent from "../../components/Loader";
import { getDateFormatIndex, getDatePatternArray } from '../../containers/WorkkardDetail/utils';
const moment = require('moment');

// Constants
const INITIAL_STATE = {
    canCreateWorkkardNote: false,
    displayTextEditor: false,
    selectedActivityId: 0,
    selectedActivityName: "",
    notesUploadedFiles: [],
    noteCustomFieldValues: {},
    currentNoteActivityInfo: {},
    isNoteTypeChange: false,
    NoteFileJson: [],
    displayEditorError: "",
    fileRemoving: false,
    enablePublishIcons: false,
    selectedNoteTypeId: 0
};

const CONFIRM_MODAL_CLASSNAMES = {
    overlayClassName: "modal",
    contentClassName: "modalContent small animated faster fadeInUpx2 confirmModal"
};
const FIELDS_TO_SKIP = ["Summary", "Attach Files", "Attach Workkard Files"];
const stripEditorChrome = (html) => (html || "").replace(/[<br><p></p>&nbsp;]/g, '').trim();

const isEditorEmpty = (html, fileCount) => stripEditorChrome(html) === "" && fileCount < 1;

const NotePanelContainer = (props) => {
    let origin = window.location.href.includes("actId")
    
    const { publicApiPostError } = props;
    const { workkardDetail, activityDetail, panelVisibility, createNote, activityListing, middlePanel } = useSelector(state => state.workkardDetail);
    const {tzData, timeZoneTz} = useSelector(state => state.sessionContextOidc);
    const moduleType = panelVisibility?.templateType;
    const moduleId = moduleType === CharConstants.Activity ? activityDetail.activityId : workkardDetail.Id;
    const { isModuleEnabled } = useModules();
    const enrichedNoteData = React.useMemo(() => {
        const actData = {
            actIds: activityListing?.activities.map((val) => val.activityId) ?? [],
            allActivities:{Activities:activityListing?.activities},
            actNames:activityListing?.activities.map((val) => val.activityName) ?? []
        };
        return {actData}
    }, [activityListing]);

    const enrichCreateNote = { ...createNote, ...enrichedNoteData };

    const [state, setState] = useState(INITIAL_STATE);
    const [currentModuleType, setCurrentModuleType] = useState(moduleType);
    const [currentModuleId, setCurrentModuleId] = useState(moduleId);
    const [noteTemplateOptions, setNoteTemplateOptions] = useState([]);
    const updateState = (partial) => {
        setState((prev) => ({
            ...prev,
            ...(typeof partial === "function" ? partial(prev) : partial)
        }));
    };

    useEffect(() => {
        const noteTemplates = createNote?.noteTemplates;
        if (noteTemplates?.length > 0) {
            const index = noteTemplates.findIndex(item => item.NoteTemplateName === "File Note");
            if (index !== -1) {
                const reordered = [...noteTemplates];
                const [fileNoteItem] = reordered.splice(index, 1);
                reordered.push(fileNoteItem);
                setNoteTemplateOptions(reordered);
            } else {
                setNoteTemplateOptions(noteTemplates);
            }
        }
    }, [createNote?.noteTemplates]);
    

    // Note template / type selection
    const onNoteTemplateClick = (notetemplateId) => {
        // const { templateId } = getTemplateInfoObjFromRedux(templatetype);
        if (currentModuleType === CharConstants.Activity) {
            updateState({
                selectedActivityId: activityDetail.activityId,
                selectedActivityName: activityDetail?.activityName
            });
        }
        props.noteTemplateClick(notetemplateId, currentModuleId, currentModuleType);
    };

    // const getTemplateInfoObjFromRedux = (templateType) => {
    //     let templateId = 0, templatetype = "", templateTypeShort = "", noteTemplateid = 0, templateShortName = '';
    //     if (templateType.toUpperCase() === CharConstants.Workkard) {
    //         templateId = workkardDetail.Id;
    //         templatetype = StringConstants.workkard;
    //         templateTypeShort = CharConstants.Workkard;
    //         noteTemplateid = enrichCreateNote.createdDraftNote ? enrichCreateNote?.createdDraftNote?.DraftNote?.NoteTemplateId : noteTemplateid;
    //     } else {
    //         templateId = state.selectedActivityId === 0 ? activityDetail?.activityId : state.selectedActivityId;
    //         templatetype = StringConstants.activity;
    //         templateTypeShort = CharConstants.Activity;
    //         noteTemplateid = enrichCreateNote.selectedNoteDraftandTemplateData ? enrichCreateNote.selectedNoteDraftandTemplateData.NoteTemplate.id : noteTemplateid;
    //         templateShortName = enrichCreateNote.selectedNoteDraftandTemplateData ? enrichCreateNote.selectedNoteDraftandTemplateData.NoteTemplate.TemplateShortName : templateShortName;
    //     }
    //     return { templateId, templatetype, templateTypeShort, noteTemplateid, templateShortName };
    // };

    // const updateState = (partial) => {
    //     setState((prev) => ({
    //         ...prev,
    //         ...(typeof partial === "function" ? partial(prev) : partial)
    //     }));
    // };

    // // Instance-like mutable values (were plain class fields).
    const preparedCustomFieldDataRef = useRef({});
    const customFieldDataDefaultValuesRef = useRef({});
    const editorContentRef = useRef("");
    // const isEventTriggeredRef = useRef(false);
    const discardNoteRedirectUrlRef = useRef(null);
    const fileUploaderRef = useRef(null);
    // const stateRef = useRef(state);
    // stateRef.current = state;
    // const propsRef = useRef(props);
    // propsRef.current = props;

    // Small shared helpers
    const showConfirmModal = ({ message, onConfirmClick, onCancelClick, confirmationText = "Confirm", cancelText = "Close", extraContentClass = "" }) => {
        props.showDialogueBox({
            flag: true,
            component: (
                <ConfirmationTextBox
                    class={"modalBody"}
                    message={message}
                    onConfirmClick={onConfirmClick}
                    onCancelClick={onCancelClick}
                    confirmationText={confirmationText}
                    footerClass={"modalFooter"}
                    cancelText={cancelText}
                />
            ),
            overlayClassName: CONFIRM_MODAL_CLASSNAMES.overlayClassName,
            contentClassName: `${CONFIRM_MODAL_CLASSNAMES.contentClassName}${extraContentClass}`,
            shouldCloseOnOverlayClick: false
        });
    };

    // const buildCustomFieldEntry = (item) => ({
    //     key: item.FieldKey,
    //     value: '',
    //     IsMandatory: item.IsMandatory,
    //     Label: item.Label,
    //     FieldType: item.fieldType,
    //     FieldSettings: item.FieldSettings
    // });

    // Shared by openAttachedWorkardFiles
    const mergeUploadedFiles = (newFiles, resetAction) => {
        const merged = [...state.NoteFileJson, ...newFiles];
        updateState({
            notesUploadedFiles: CommonUtil.removeDuplicates(merged, 'guid'),
            fileRemoving: true
        });
        props.hideDialogueBox();
        resetAction();
    };

    // // Redux-derived lookups
    // const getTemplateInfoObjFromRedux = (templateType) => {
    //     let templateId = 0, templatetype = "", templateTypeShort = "", noteTemplateid = 0, templateShortName = '';
    //     if (templateType.toUpperCase() === CharConstants.Workkard) {
    //         templateId = workkardDetail.Id;
    //         templatetype = StringConstants.workkard;
    //         templateTypeShort = CharConstants.Workkard;
    //         noteTemplateid = enrichCreateNote.createdDraftNote ? enrichCreateNote?.createdDraftNote?.DraftNote?.NoteTemplateId : noteTemplateid;
    //     } else {
    //         templateId = state.selectedActivityId === 0 ? activityDetail?.activityId : state.selectedActivityId;
    //         templatetype = StringConstants.activity;
    //         templateTypeShort = CharConstants.Activity;
    //         noteTemplateid = enrichCreateNote.selectedNoteDraftandTemplateData ? enrichCreateNote.selectedNoteDraftandTemplateData.NoteTemplate.id : noteTemplateid;
    //         templateShortName = enrichCreateNote.selectedNoteDraftandTemplateData ? enrichCreateNote.selectedNoteDraftandTemplateData.NoteTemplate.TemplateShortName : templateShortName;
    //     }
    //     return { templateId, templatetype, templateTypeShort, noteTemplateid, templateShortName };
    // };

    // Resets the panel back to its "no note open" state. Shared by
    // onPannelCloseClick and onCloseNoteTemplateClick, which previously
    // duplicated this object literal.
    const resetToNoteListPanel = () => {
        props.setPanelVisibility({
            isLeftVisible: !(panelVisibility?.isFullViewActive || panelVisibility?.isVisibleExternalApp),
            isRightVisible: true,
            isNoteVisible: false,
            isNoteCreationVisible: false,
            showWkInMobileView: false
        });
    };

    const onPannelCloseClick = (value) => {
        if (value === "selectNote") {
            if (props.referrer === "views" && panelVisibility?.templateType !== CharConstants.Workkard) {
                props.onClose();
            }
            resetToNoteListPanel();
        }
        if (value === "createNote" || value === "discardNote") {
            onCloseNoteTemplateClick();
        }
    };

    const onCloseNoteTemplateClick = () => {
        if (isEditorEmpty(editorContentRef.current, state.NoteFileJson.length)) {
            resetToNoteListPanel();
            return;
        }

        showConfirmModal({
            message: ADD_NOTE_ERROR_MESSAGE.discardNoteText,
            onConfirmClick: () => {resetToNoteListPanel(); props.hideDialogueBox()},
            onCancelClick: props.hideDialogueBox,
            confirmationText: "Confirm"
        });
    };

    // const ondiscardNoteTemplateClick = (onClose = false) => {
    //     const hasNoUnsavedContent = !validateTextEditor(false) && !validateEmptyCustomFieldData();
    //     if (hasNoUnsavedContent || onClose === true) {
    //         props.hideDialogueBox();
    //         return;
    //     }

    //     showConfirmModal({
    //         message: ADD_NOTE_ERROR_MESSAGE.discardNoteText,
    //         onConfirmClick: () => resetToNoteListPanel(),
    //         onCancelClick: props.hideDialogueBox,
    //         confirmationText: "Confirm"
    //     });
    // };

    const onWorkkardClick = () => {
        if (props.referrer === "views") {
            window.open('/getclmdetail?cId=' + workkardDetail.Id, '_blank');
            return;
        }
        if (panelVisibility?.isNotificationPanelOpen) {
            CommonUtil.removeClass(document.querySelector("body"), 'au_fixed_right');
            CommonUtil.removeClass(document.querySelector("body"), 'openNotification');
            props.setPanelVisibility({ isNotificationPanelOpen: false });
            $(".headerRight li").removeClass("active");
            props.hideRightPopUpBox();
        }
        props.setPanelVisibility({
            isRightVisible: true,
            isRightPanelExpand: true
        });
    };

    // const closeNoteAtviewEnd = () => {
    //     props.setPanelVisibility({
    //         templateType: "A",
    //         isNoteVisible: false,
    //         isNoteCreationVisible: false
    //     });
    //     props.onClose();
    // };
    const closeNoteAtviewEnd = () => {
        props.setPanelVisibility({
            templateType: "A",
            isNoteVisible: false,
            isNoteCreationVisible: false
        });
        props.onClose();
    };

    const onNoteTemplateTypeChange = (e) => {
        if (!e.target.value) return;
        const getModuleId = (e.target.value == CharConstants.Workkard) ? workkardDetail.Id : currentModuleId;
        props.onChangeModuleType({
            moduleId: getModuleId,
            nttype: e.target.value
        });
        preparedCustomFieldDataRef.current = {};
    };

    const onNoteTemplateActivityChange = (e) => {
        if (!e.target.value) return;
        updateState({ selectedActivityId: e.target.value });
        const payload = {
            moduleId: e.target.value,
            nttype: CharConstants.Activity,
            requestFrom: 'create_note'
        }
        props.onActivityChange(payload);
        // props.onNoteTemplateActivityChange(payload);
    };

    // const onNoteTemplateClick = (notetemplateId) => {
    //     // const { templateId } = getTemplateInfoObjFromRedux(templatetype);
    //     if (currentModuleType === CharConstants.Activity) {
    //         updateState({
    //             selectedActivityId: activityDetail.activityId,
    //             selectedActivityName: activityDetail?.activityName
    //         });
    //     }
    //     props.noteTemplateClick(notetemplateId, moduleId, currentModuleType);
    // };

    const onNoteTypeChange = (e, previousNoteTypeId) => {
        const notetemplateId = e.target.value;
        if (!notetemplateId) return;
        
        updateState({ selectedNoteTypeId: notetemplateId});

        const hasCustomFieldValues = Object.values(preparedCustomFieldDataRef.current).some((field) => field?.value?.trim());
        const isNoteFormHasNoData = !hasCustomFieldValues && !editorContentRef.current;
        if (isNoteFormHasNoData) {
            props.noteTemplateClick(notetemplateId, currentModuleId, currentModuleType);
            preparedCustomFieldDataRef.current = {};
            updateState({ isNoteTypeChange: true });
            return;
        }
        showConfirmModal({
            message: ADD_NOTE_ERROR_MESSAGE.changeTemplate,
            onConfirmClick: () => {
                props.noteTemplateClick(notetemplateId, currentModuleId, currentModuleType);
                const currentPrepared = preparedCustomFieldDataRef.current;
                for (const key in currentPrepared) {
                    $('#' + currentPrepared[key].key + 'errorBlock').text('');
                }
                updateState({ displayEditorError: "", isNoteTypeChange: true });
                preparedCustomFieldDataRef.current = {};
                props.hideDialogueBox()
            },
            onCancelClick: () => {
                updateState({ selectedNoteTypeId: previousNoteTypeId });
                props.hideDialogueBox();
            },
            confirmationText: "Confirm",
            cancelText: "Cancel",
            extraContentClass: " noteTypeModal"
        });
    };

    // Editor content
    const editorChangeHandler = (editorContent) => {
        const enableIcon = !isEditorEmpty(editorContent, state.NoteFileJson.length);
        editorContentRef.current = editorContent;
        if (state.displayEditorError !== "" || state.enablePublishIcons !== enableIcon) {
            updateState({ displayEditorError: "", enablePublishIcons: enableIcon });
        }
    };

    // Form validation
    const getNoteFormDataForPost = (privacy = "") => {
        const resultData = {};
        const {noteData} = enrichCreateNote;
        const isSharedTemplate = activityDetail?.assigneeOrgId !== activityDetail?.ownerOrgId;
        const preparedCustomFieldData = preparedCustomFieldDataRef.current;
        
        for (const key in preparedCustomFieldData) {
            if (!preparedCustomFieldData.hasOwnProperty(key)) continue;

            const fieldEl = $(`div[data-field-key*=${key}]`);
            const isHiddenField = $("div").is(`[data-field-key*=${key}]`) && !fieldEl.is(":visible");
            if (isHiddenField || preparedCustomFieldData[key].value == null) continue;

            if ((key.includes("date") || key.includes("datetime")) && !key.includes("timezone")) {
                resultData[key + '_iso'] = CommonUtil.convertDateTimeToISOString(preparedCustomFieldData[key].value);
            } else if (key.includes('_decimal')) {
                resultData[key] = preparedCustomFieldData[key].value.replaceAll(',', '');
            } else {
                resultData[key] = preparedCustomFieldData[key].value.toString().trim();
            }
        }

        const noteFieldsForPost = {
            templateType: noteData.shortName,
            hdnNotePrivacy: privacy,            
            txtareaAddNote: editorContentRef.current,
            NoteFileJson: state.NoteFileJson,
            itemId: currentModuleId,
            type: noteData.module.toLowerCase(),
            currentActivity: activityDetail.activityId,
            showToastAction: (origin && middlePanel.activeTab === 0 && middlePanel.notes.type === noteData.module.toLowerCase()), // Line used to show actions in toast pannel
            templateSharingEnabled: isSharedTemplate
        };
        return { ...noteFieldsForPost, templateFields: resultData };
    };

    const isFieldVisible = (key) => !($("div").is(`[data-field-key*=${key}]`) && !$(`div[data-field-key*=${key}]`).is(":visible"));

    const validateFields = () => {
        let isValid = validateTextEditor();
        const preparedCustomFieldData = preparedCustomFieldDataRef.current;
        for (const key in preparedCustomFieldData) {
            if (!isFieldVisible(key)) continue;
            if (!validateIndividualFields(key)) isValid = false;
        }
        return isValid;
    };

    // Validate only for the "New Assignment" note template.
    const validateForNewAssignmentTemplate = (key) => {
        const preparedCustomFieldData = preparedCustomFieldDataRef.current;
        const fieldIsVisibleAndEmpty = $("div").is(`[data-field-key*=${key}]`)
            && $(`div[data-field-key*=${key}]`).is(":visible")
            && ($(`#${key}`).val() == -1 || $(`#${key}`).val() == "");

        if (fieldIsVisibleAndEmpty) {
            $('#' + preparedCustomFieldData[key].key + 'errorBlock').text(preparedCustomFieldData[key].Label + ' is required.');
            return false;
        }
        return true;
    };

    const validateTextEditor = (showError = true) => {
        if (isEditorEmpty(editorContentRef.current, state.NoteFileJson.length)) {
            if (showError) {
                updateState({ displayEditorError: ADD_NOTE_ERROR_MESSAGE.addDescription });
            }
            return false;
        }
        editorContentRef.current = editorContentRef.current.length < 1 ? '<p></p>' : editorContentRef.current;
        return true;
    };

    // const validateEmptyCustomFieldData = () => {
    //     const preparedCustomFieldData = preparedCustomFieldDataRef.current;
    //     return Object.keys(preparedCustomFieldData).some((key) => {
    //         const field = preparedCustomFieldData[key];
    //         return field && (field.value.trim() !== "" || field.value.trim() > "-1");
    //     });
    // };

    // validateIndividualFields helpers — each isolates one validation rule
    const applyDefaultValueIfEmpty = (field, defaultEntry) => {
        if (!defaultEntry?.value) return;
        field.value = field.value.trim() === "" ? (defaultEntry.value.trim() || "") : field.value;
    };

    const validateMandatory = (field, errorBlockSelector) => {
        if (!field.IsMandatory) return true;

        const isEmpty = field.value.trim() === "" || field.value.trim() === "-1";
        $(errorBlockSelector).text(isEmpty ? field.Label + ' is required.' : '');
        return !isEmpty;
    };

    // (VALIDATE_SPECIAL_CHAR_FIELD_ARRAY) — license numbers get a stricter regex.
    const validateSpecialChars = (field, errorBlockSelector) => {
        if (!VALIDATE_SPECIAL_CHAR_FIELD_ARRAY.includes(field.Label.toLowerCase())) return true;
        if (field.value === '') {
            $(errorBlockSelector).text('');
            return true;
        }

        const isLicenseField = field.Label.toLowerCase() === "adjuster license number";
        const regex = isLicenseField
            ? /^[a-zA-Z0-9 ()&]*$/
            : /^[a-zA-Z0-9 ~`@#$%*)(_{}:;"\/\[\]',&.-]+$/;
        const errorMessage = isLicenseField
            ? "Invalid License Number. " + LICENSE_NUMERIC_VALIDATION_MSG
            : SPECIAL_CHAR_VALIDATION_MSG;

        const isValid = regex.test(field.value);
        $(errorBlockSelector).text(isValid ? '' : errorMessage);
        return isValid;
    };

    const isNewAssignmentTemplateSelected = () => Object.values(TEMPLATE_VALUES).includes($('#noteSelectNoteTypeChange').find(":selected").text());

    // Extracted from the switch statement inside validateIndividualFields so the
    // per-type rules can be scanned/tested independently of the DOM lookups above.
    const validateFieldByType = (field, errorBlockSelector) => {
        switch (field.FieldType) {
            case 'decimal': {
                const regex = /(?=.)^(([0-9][0-9]{0,2}(,[0-9]{3})*)|0)?(\.[0-9]{1,2})?$/;
                const result = regex.test(field.value);
                $(errorBlockSelector).text(result ? "" : "#,###.## is required format. Numbers and Decimal Only");
                return result;
            }
            case 'date': {
                const inputDate = moment(field.value.trim()).format(DATE_FORMAT);
                const regex = /\b\d{1,2}[\/-]\d{1,2}[\/-]\d{4}\b/;
                if (!regex.test(inputDate) || CommonUtil.isInValidDate(inputDate)) {
                    $(errorBlockSelector).text(field.Label + ' is invalid.');
                    return false;
                }
                $(errorBlockSelector).text('');
                return true;
            }
            case 'datetime': {
                const date = moment(field.value.trim(), DATE_FORMAT);
                if (CommonUtil.isInValidDate(date)) {
                    $(errorBlockSelector).text(field.Label + ' is invalid.');
                    return false;
                }
                $(errorBlockSelector).text('');
                return true;
            }
            case 'email': {
                const emailRegex = /^([A-Za-z0-9_\-\.])+\@([A-Za-z\-])+\.([A-Za-z]{2,4})$/;
                const isValidEmail = emailRegex.test(field.value.trim());
                $(errorBlockSelector).text(isValidEmail ? "" : field.Label + ' is invalid.');
                return isValidEmail;
            }
            default:
                return true;
        }
    };
    
    const validateIndividualFields = (key) => {
        const preparedCustomFieldData = preparedCustomFieldDataRef.current;
        const customFieldDataDefaultValues = customFieldDataDefaultValuesRef.current;
        const field = preparedCustomFieldData[key];
        const errorBlockSelector = '#' + field.key + 'errorBlock';

        applyDefaultValueIfEmpty(field, customFieldDataDefaultValues[key]);

        let isValid = validateMandatory(field, errorBlockSelector);

        if (isValid) {
            isValid = validateSpecialChars(field, errorBlockSelector);
        }

        if (field.value !== "" && field.value != null) {
            isValid = validateFieldByType(field, errorBlockSelector) && isValid;
        }

        if (isNewAssignmentTemplateSelected() && !field.IsMandatory && isValid) {
            isValid = validateForNewAssignmentTemplate(key);
        }

        return isValid;
    };

    // Publish / draft actions
    const publishWith = (privacy) => {
        if (!props.buttonLoading && state.enablePublishIcons && validateFields()) {
            props.onPublishNoteHandler(getNoteFormDataForPost(privacy));
        }
    };
    const onPublishInternal = () => publishWith(StringConstants.Private);
    const onPublishPublic = () => publishWith(StringConstants.Public);

    // const onSaveAsDraft = () => {
    //     if (validateFields()) {
    //         props.onSaveAsDraft(getNoteFormDataForPost());
    //         return;
    //     }
    //     props.hideDialogueBox();
    //     if (props.referrer === "views") {
    //         props.onClose();
    //     }
    // };

    // Custom field wiring
    const getCustomFieldValues = (e) => {
        const fieldStates = { ...preparedCustomFieldDataRef.current };
        fieldStates[e.name] = { ...fieldStates[e.name], value: e.value };
        preparedCustomFieldDataRef.current = fieldStates;
    };

    const setCustomFieldDefaultValues = (e) => {
        const fieldStates = { ...customFieldDataDefaultValuesRef.current };
        fieldStates[e.name] = { ...fieldStates[e.name], value: e.value };
        customFieldDataDefaultValuesRef.current = fieldStates;
    };
    const resolveWorkkardPropertyTimezone = () => {
        const tzField = workkardDetail?.CustomFields?.find((obj) => obj.FieldKey === "policyeffectivedate_timezone");
        const wkpropertyTz = tzField?.Value;
        if (wkpropertyTz && tzData?.length > 0) {
            const matchedTz = tzData.find((item) => item.DisplayText === wkpropertyTz);
            return matchedTz?.UniversalTimeZoneId ?? timeZoneTz;
        }
        return timeZoneTz;
    };

    const bindCustomFields = () => {
        const customFields = enrichCreateNote?.noteData?.customFields;
        if (!customFields || customFields.length === 0) return "";
        
        const { WorkkardLossDate, CreatedDateString } = workkardDetail || {};
        const createdDateFallback = workkardDetail.TemplateId === 0 ? CreatedDateString : "01/01/0001"; // default date for underwriting wk
        let activityMinDate = WorkkardLossDate || createdDateFallback;

        const activityMinDateArr = getDatePatternArray(activityMinDate || moment().format(DEFAULT_DATE_FORMAT));
        const dateIndex = getDateFormatIndex();
        activityMinDate = `${activityMinDateArr[dateIndex.month]}/${activityMinDateArr[dateIndex.day]}/${activityMinDateArr[dateIndex.year]}`;

        // const filledData = enrichCreateNote.selectedNoteDraftandTemplateData.DraftNote.DraftNoteCustomFields || [];
        const normalizedCustomFields = customFields.map(({ options, label, sequence, isRequired, fieldName, ...rest }) => ({
            ...rest,
            FieldType: rest.fieldType,
            FieldKey: fieldName,
            Label: label,
            SequenceNumber: sequence,
            IsMandatory: isRequired,
            CustomFieldValues: options?.map(({ key, value }) => ({
                SequenceNumber: key,
                value,
                DisplayName: value
            })) ?? []
        }));
        const preparedCustomData = normalizedCustomFields.map((item) => {
            return {
                data: { ...item},
                group: item?.fieldType.toLowerCase()
            };
        });

        const seededCustomFieldData = { ...preparedCustomFieldDataRef.current };
        normalizedCustomFields.forEach((item) => {
            seededCustomFieldData[item.FieldKey] = {
                key: item.FieldKey,
                IsMandatory: item.IsMandatory,
                Label: item.Label,
                FieldType: item.FieldType,
                FieldSettings: item.fieldSettings,
                value: seededCustomFieldData[item.FieldKey]?.value ?? ''
            };
        });
        preparedCustomFieldDataRef.current = seededCustomFieldData;

        const normalizedTzData = tzData.map((val)=>{
            return {
                Id: val.id,
                UniversalTimeZoneId: val.standard_time_zone,
                WindowsTimeZoneId: val.source_time_zone,  
                DisplayText: val.display_value,
                IsActive: val.is_active,
                MappingTimezone: val.mapped_time_zone
            }
        })
        
        return (
            <FieldRenderingEngine
                getTimezoneByZip={props.getTimezoneByZip}
                timeZoneValue={resolveWorkkardPropertyTimezone()}
                userTimeZoneValue={timeZoneTz}
                data={preparedCustomData}
                customFieldsData={{
                    actDetail: activityDetail?.customFields,
                    wrkdDetail: workkardDetail?.CustomFields
                }}
                tzData={normalizedTzData}
                renderLocation={"create"}
                pastDate={activityMinDate}
                futureDate={null}
                renderType={'note'}
                showLabel={true}
                customData={true}
                setDefaultValue={setCustomFieldDefaultValues}
                onFieldValueChange={getCustomFieldValues}
            />
        );
    };

    // const getNoteCustomFieldValuesOnEdit = () => {
    //     const customFields = enrichCreateNote.selectedNoteDraftandTemplateData.NoteTemplate.NoteTemplateCustomFields || [];
    //     customFields.forEach((item) => {
    //         if (!FIELDS_TO_SKIP.includes(item.FieldDescription)) {
    //             preparedCustomFieldDataRef.current[item.FieldKey] = buildCustomFieldEntry(item);
    //         }
    //     });

    //     const filledData = enrichCreateNote.selectedNoteDraftandTemplateData.DraftNote.DraftNoteCustomFields || [];
    //     filledData.forEach((item) => {
    //         const entry = preparedCustomFieldDataRef.current[item.FieldKey];
    //         if (entry && entry.value === "") {
    //             preparedCustomFieldDataRef.current[item.FieldKey] = { ...entry, value: item.CustomFieldValue };
    //         }
    //     });
    // };

    // File attachments
    const onsaveAndUpdateFileCaption = (notesInfo) => {
        updateState({
            NoteFileJson: notesInfo,
            enablePublishIcons: !isEditorEmpty(editorContentRef.current, notesInfo.length)
        });
    };
    
    // Open Workkard Files
    const openAttachedWorkardFiles = () => {
        props.showDialogueBox({
            flag: true,
            component: (
                <AttachedWorkkardFiles
                    hideDialogueBox={() => { props.hideDialogueBox(); props.resetAttachedWorkkardFiles(); }}
                    OnAttchFiles={(data) => mergeUploadedFiles(data, props.resetAttachedWorkkardFiles)}
                />
            ),
            overlayClassName: "modal animated faster fadeIn",
            contentClassName: "modalContent animated faster fadeInUpx2 medium",
            shouldCloseOnOverlayClick: true
        });
    };

    const handleNoteUploadFiles = (data) => {
        updateState({ notesUploadedFiles: data, fileRemoving: true });
    };

    const handleDropFiles = (files) => {
        fileUploaderRef.current.uploadFile(files);
    };

    const setFalseRemovingState = () => {
        updateState({ fileRemoving: false });
    };

    // Publish button rendering
    const PublishButton = ({ id, label, iconSrc, iconName, disabled, onClick }) => (
        <button
            type="button"
            id={id}
            className={`btn btnSqure ${id === 'publishPublic' ? 'public alignMiddle' : ''} buttonGradient ${disabled ? 'disabled' : ''}`}
            onClick={onClick}
        >
            {iconSrc
                ? <img className="icon" src={iconSrc} alt="" />
                : <Icon name={iconName} className="icon white mr" />}
            {label}
        </button>
    );

    const renderPublishButtons = () => {
        const {noteData} = enrichCreateNote;

        const disabled = !(state.enablePublishIcons && !props.buttonLoading);
        const publicBtn = (
            <PublishButton id="publishPublic" label="Public note" iconName="public" disabled={disabled} onClick={onPublishPublic} />
        );
        const internalBtn = (
            <PublishButton
                id="publishPrivate"
                label="Internal note"
                iconSrc={IMAGE_BASE_PATH + "/images/icons/note-internal.svg"}
                disabled={disabled}
                onClick={onPublishInternal}
            />
        );

        const isRejectedActivity = currentModuleType === CharConstants.Activity && activityDetail?.resolution?.toLowerCase() === 'rejected';

        if (!noteData.private && !noteData.public) return;
        if (!noteData.public && isModuleEnabled("notes.visibility.internal")) return noteData.private === false ? null : internalBtn;
        if (!noteData.private && isModuleEnabled("notes.visibility.public")) return isRejectedActivity ? null : publicBtn;
        return isRejectedActivity ? internalBtn : <>{publicBtn}{internalBtn}</>;
    };

    // // Discard-on-navigate event bridge
    // const onDiscardEventTriggeredImplRef = useRef(null);
    // onDiscardEventTriggeredImplRef.current = (type) => {
    //     const hasData = stateRef.current.enablePublishIcons || validateEmptyCustomFieldData();
    //     discardNoteRedirectUrlRef.current = type.detail.redirectUrl;
    //     if (hasData) {
    //         isEventTriggeredRef.current = true;
    //         ondiscardNoteTemplateClick();
    //     } else {
    //         window.location.href = type.detail.redirectUrl;
    //     }
    // };
    // const onDiscardEventTriggeredRef = useRef((type) => onDiscardEventTriggeredImplRef.current(type));
    // const onDiscardEventTriggered = onDiscardEventTriggeredRef.current;

    // // Lifecycle: mount / unmount
    // // ---------------------------------------------------------------------------
    // // Mount-effect helpers (each isolates one branch of the old effect body)
    // // ---------------------------------------------------------------------------

    const initializeWorkkardNoteContent = () => {
        editorContentRef.current = enrichCreateNote.createdDraftNote.DraftNote.Description;
        updateState({
            enablePublishIcons: !enrichCreateNote.createdDraftNote.DraftNote.Description
        });
    }; 

    const initializeActivityNoteContent = () => {        
        updateState({
            selectedActivityId: activityDetail?.activityId,
            selectedActivityName: activityDetail?.activityName,
            currentNoteActivityInfo: activityDetail
        });
    };
    
    const initializeEditorContent = () => {
        if (editorContentRef.current !== "") return;

        if (panelVisibility?.templateType === CharConstants?.Workkard && enrichCreateNote.createdDraftNote) {
            initializeWorkkardNoteContent();
        }
        if (panelVisibility?.templateType === CharConstants?.Activity) {
            initializeActivityNoteContent();
        }
    };

    const initializeWorkkardNotePermissions = () => {
        if (!workkardDetail?.ActionMenu) return;
        const menuActions = CommonUtil.getMenuActions(WorkkardActions, workkardDetail.ActionMenu);
        if (menuActions.some((item) => item.value.includes(StringConstants.AddNote))) {
            updateState({ canCreateWorkkardNote: true });
        }
    };

    // const getDraftNoteFilesAndCustomFieldsFlag = () => {
    //     if (enrichCreateNote?.selectedNoteDraftandTemplateData && enrichCreateNote.templateType === CharConstants.Activity) {
    //         const fields = enrichCreateNote.selectedNoteDraftandTemplateData.DraftNote.DraftNoteCustomFields;
    //         return {
    //             draftNoteFiles: enrichCreateNote.selectedNoteDraftandTemplateData.DraftNote.Files,
    //             noteCustomFields: !!(fields && fields.length > 0)
    //         };
    //     }
    //     if (enrichCreateNote?.createdDraftNote && enrichCreateNote.templateType === CharConstants.Workkard) {
    //         return { draftNoteFiles: enrichCreateNote.createdDraftNote.DraftNote.Files, noteCustomFields: false };
    //     }
    //     return { draftNoteFiles: [], noteCustomFields: false };
    // };

    // const initializeUploadedFiles = () => {
    //     if (!enrichCreateNote) return;
    //     const { draftNoteFiles, noteCustomFields } = getDraftNoteFilesAndCustomFieldsFlag();
    //     updateState({ notesUploadedFiles: draftNoteFiles });
    //     if (noteCustomFields) {
    //         getNoteCustomFieldValuesOnEdit();
    //     }
    // };

    // const handleReferrerViewsUnmount = () => {
    //     if (stateRef.current.enablePublishIcons) {
    //         onCloseNoteTemplateClick();
    //     } else {
    //         propsRef.current.setPanelVisibility({
    //             templateType: "A",
    //             isNoteVisible: false,
    //             isNoteCreationVisible: false
    //         });
    //     }
    // };

    // const handleMountEffectUnmount = () => {
    //     delete window.isNewLayoutEnabled;
    //     discardNoteRedirectUrlRef.current = null;
    //     isEventTriggeredRef.current = false;
    //     propsRef.current.resetPostApiActionError();
    //     window.removeEventListener('shouldDiscardNote', onDiscardEventTriggered);

    //     if (propsRef.current.panelVisibility.isNotificationPanelOpen) {
    //         CommonUtil.removeClass(document.querySelector("body"), 'openNotification');
    //         return;
    //     }
    //     if (propsRef.current.referrer === "views" && $(".headerRight li").is('[name]')) {
    //         handleReferrerViewsUnmount();
    //     }
    // };

    // // Lifecycle: mount / unmount
    useEffect(() => {
        // window.addEventListener('shouldDiscardNote', onDiscardEventTriggered);
        // if (!window.hasOwnProperty("isNewLayoutEnabled")) {
        //     window.isNewLayoutEnabled = () => true;
        // }
        initializeEditorContent();
        initializeWorkkardNotePermissions();
        // initializeUploadedFiles();

        updateState({ displayTextEditor: true });

        // return handleMountEffectUnmount;
    }, []);

    // // Lifecycle: componentWillReceiveProps equivalent
    // const isFirstRenderRef = useRef(true);
    // const prevPropsRef = useRef(props);

    // useEffect(() => {
    //     if (isFirstRenderRef.current) {
    //         isFirstRenderRef.current = false;
    //         prevPropsRef.current = props;
    //         return;
    //     }

    //     const prevProps = prevPropsRef.current;
    //     const newProp = props;

    //     if (newProp.panelVisibility !== prevProps.panelVisibility && newProp.panelVisibility.isNoteCreationVisible) {
    //         handlePanelBecameVisible(newProp);
    //     }

    //     if (!newProp.buttonLoading && (newProp.enrichCreateNote.createdDraftNote !== "" || newProp.enrichCreateNote.selectedNoteDraftandTemplateData || newProp.enrichCreateNote.saveNoteErrorText.length > 0)) {
    //         handleCreateNoteDataChanged(newProp);
    //     }

    //     if (newProp.enrichCreateNote.discardNoteRedirectUrl && newProp.enrichCreateNote.discardNoteRedirectUrl !== "") {
    //         onDiscardEventTriggered({ detail: { redirectUrl: newProp.enrichCreateNote.discardNoteRedirectUrl } });
    //     }

    //     prevPropsRef.current = props;
    // }, [props]);

    // const handlePanelBecameVisible = (newProp) => {
    //     if (newProp?.workkardDetail?.ActionMenu) {
    //         const menuActions = CommonUtil.getMenuActions(WorkkardActions, newProp.workkardDetail.ActionMenu);
    //         updateState({ canCreateWorkkardNote: menuActions.some((item) => item.value.includes(StringConstants.AddNote)) });
    //     } else {
    //         updateState({ canCreateWorkkardNote: false });
    //     }

    //     if (newProp.panelVisibility.templateType === CharConstants.Workkard && newProp.enrichCreateNote.createdDraftNote) {
    //         const description = newProp.enrichCreateNote.createdDraftNote.DraftNote.Description;
    //         editorContentRef.current = description || editorContentRef.current;
    //         preparedCustomFieldDataRef.current = {};
    //         updateState({
    //             placeholderText: "You are adding note in " + newProp.workkardDetail.WorkkardNumber + "...",
    //             enablePublishIcons: !isEditorEmpty(editorContentRef.current, stateRef.current.NoteFileJson.length)
    //         });
    //     }

    //     if (newProp.panelVisibility.templateType === CharConstants.Activity && newProp.enrichCreateNote.selectedNoteDraftandTemplateData) {
    //         handleActivityTemplateVisible(newProp);
    //     }
    // };

    // const handleActivityTemplateVisible = (newProp) => {
    //     let activityName = stateRef.current.selectedActivityName;
    //     let actId = stateRef.current.selectedActivityId;
    //     let actInfo = {};

    //     const description = newProp.enrichCreateNote.selectedNoteDraftandTemplateData.DraftNote.Description;
    //     editorContentRef.current = description || editorContentRef.current;

    //     if (newProp.enrichCreateNote.activitiesInfo && newProp.enrichCreateNote.activitiesInfo.activities.Total > 0) {
    //         const draftNoteTypeId = newProp.enrichCreateNote.selectedNoteDraftandTemplateData.DraftNote.TypeId;
    //         if (draftNoteTypeId > 0) {
    //             const match = newProp.enrichCreateNote.activitiesInfo.activities.Activities.find((a) => a.ActivityId == draftNoteTypeId);
    //             if (match) {
    //                 activityName = match.ActivityName;
    //                 actId = match.ActivityId;
    //                 actInfo = match;
    //             }
    //         } else {
    //             activityName = newProp.enrichCreateNote.actTitle;
    //         }
    //     }

    //     const filledData = { ...preparedCustomFieldDataRef.current };
    //     preparedCustomFieldDataRef.current = {};
    //     const customFields = newProp.enrichCreateNote.selectedNoteDraftandTemplateData.NoteTemplate.NoteTemplateCustomFields || [];
    //     customFields.forEach((item) => {
    //         if (FIELDS_TO_SKIP.includes(item.FieldDescription)) return;
    //         preparedCustomFieldDataRef.current[item.FieldKey] = filledData.hasOwnProperty(item.FieldKey)
    //             ? { ...filledData[item.FieldKey] }
    //             : buildCustomFieldEntry(item);
    //     });

    //     updateState({
    //         selectedActivityName: activityName,
    //         selectedActivityId: actId,
    //         placeholderText: "You are adding note in " + activityName + "...",
    //         currentNoteActivityInfo: Object.keys(stateRef.current.currentNoteActivityInfo).length === 0 ? actInfo : stateRef.current.currentNoteActivityInfo,
    //         enablePublishIcons: isEditorEmpty(editorContentRef.current, stateRef.current.NoteFileJson.length),
    //         selectedNoteTypeId: newProp.enrichCreateNote.selectedNoteDraftandTemplateData.NoteTemplate.id || 0
    //     });
    // };

    // const handleCreateNoteDataChanged = (newProp) => {
    //     let draftNoteFiles = [];
    //     let noteCustomFields = false;

    //     if (newProp?.enrichCreateNote.selectedNoteDraftandTemplateData && newProp.enrichCreateNote.templateType === CharConstants.Activity) {
    //         draftNoteFiles = newProp.enrichCreateNote.selectedNoteDraftandTemplateData.DraftNote.Files;
    //         const fields = newProp.enrichCreateNote.selectedNoteDraftandTemplateData.DraftNote.DraftNoteCustomFields;
    //         if (fields != null && fields.length > 0 && Object.keys(preparedCustomFieldDataRef.current).length === 0) {
    //             noteCustomFields = true;
    //         } else if (stateRef.current.isNoteTypeChange && (fields == null || fields.length === 0)) {
    //             const customFields = newProp.enrichCreateNote.selectedNoteDraftandTemplateData.NoteTemplate.NoteTemplateCustomFields || [];
    //             customFields.forEach((item) => {
    //                 if (!FIELDS_TO_SKIP.includes(item.FieldDescription)) {
    //                     preparedCustomFieldDataRef.current[item.FieldKey] = buildCustomFieldEntry(item);
    //                 }
    //             });
    //         }
    //     } else if (newProp?.enrichCreateNote.createdDraftNote && newProp.enrichCreateNote.templateType === CharConstants.Workkard) {
    //         draftNoteFiles = newProp.enrichCreateNote.createdDraftNote.DraftNote.Files;
    //     }

    //     updateState({
    //         notesUploadedFiles: draftNoteFiles,
    //         isNoteTypeChange: false,
    //         selectedNoteTypeId: newProp?.enrichCreateNote?.selectedNoteDraftandTemplateData?.NoteTemplate?.id
    //     });

    //     if (noteCustomFields) {
    //         getNoteCustomFieldValuesOnEdit();
    //     }

    //     if (newProp.enrichCreateNote.saveNoteErrorText.length > 0) {
    //         showConfirmModal({
    //             message: newProp.enrichCreateNote.saveNoteErrorText,
    //             onConfirmClick: props.hideDialogueBox,
    //             onCancelClick: props.hideDialogueBox,
    //             confirmationText: "Okay",
    //             cancelText: "Cancel"
    //         });
    //     }
    // };

    const enableAttachLetter = process.env.enable_attach_letter;    
    return (
        <div className={"notesCreateContainer noteCreationMob"}>
            {enrichCreateNote?.isLoading && <LoaderComponent />}

            {props.referrer === "views" && enrichCreateNote.SaveNoteErrorTextByViews.length > 0 &&
                <div className="colFlex alignCenter exist">
                    <h1 className="mb">{enrichCreateNote.SaveNoteErrorTextByViews}</h1>
                    <button type="button" className="pointer btn buttonGradient" onClick={closeNoteAtviewEnd}>Close</button>
                </div>
            }

            {!panelVisibility?.isNoteCreationVisible && panelVisibility?.isNoteVisible && panelVisibility?.templateType !== CharConstants.Workkard && noteTemplateOptions?.length > 0 &&
                <div className="noteListType animated faster fadeInRight">
                    <div className="detailHeader">
                        <div className="detailHeaderLeft">
                            <h3>Select Notes Type</h3>
                        </div>
                        <div className="detailHeaderRight">
                            <button type="button" className="close btn-cc__transparent" onClick={() => onPannelCloseClick('selectNote')}>
                                <Icon name="close" className="icon" />
                            </button>
                        </div>
                    </div>
                    <ul className="colFlex scrollArea cardScroll selectNote">
                        {noteTemplateOptions.map((item, index) => (
                            <li className="alignMiddle" key={item.Id}>
                                <input name="note_template" type="radio" id={"template_" + index} onClick={() => onNoteTemplateClick(item.Id)} />
                                <label htmlFor={"template_" + index}>{item.NoteTemplateName}</label>
                                {item.TemplateDescription && !item.IsDefault && item.IsVisible &&
                                    <label className="ml">{`(${item.TemplateDescription})`}</label>
                                }
                            </li>
                        ))}
                    </ul>
                </div>
            }

            {panelVisibility?.isNoteCreationVisible &&
                <DropZone handleDrop={handleDropFiles}>
                    <div className="noteCreation animated faster fadeInRight">
                        <div className="detailHeader mb__8">
                            <div className="detailHeaderLeft">
                                <div className="noteSelect alignMiddle flexGrow">
                                    <label className="mrNone">Adding</label>
                                    <select className="ml mr wth-3" id="noteSelectTemplateChange" value={enrichCreateNote.templateType} onChange={onNoteTemplateTypeChange}>
                                        {activityListing.total > 0 &&
                                            <option key="A" value="A">Activity Notes</option>
                                        }
                                        {state.canCreateWorkkardNote &&
                                            <option key="W" value="W">Workkard Notes</option>
                                        }
                                    </select>
                                    {enrichCreateNote.templateType === CharConstants.Activity &&
                                        <select className="wth-5" id="noteSelectActivityChange" value={state.selectedActivityId} onChange={onNoteTemplateActivityChange}>
                                            {enrichCreateNote?.actData?.allActivities?.Activities.map((item, index) => (
                                                <option key={`${item.activityId}-${index}`} value={item.activityId}>
                                                    {item.activityName}
                                                </option>
                                            ))}
                                        </select>
                                    }
                                </div>
                            </div>
                            <div className="detailHeaderRight">
                                <div className="userGroup mobUser">
                                    <div className="userPic"><span className="badges orangeLight">W</span></div>
                                    <button type="button" className="btn-cc__link btn-cc__link__blue mrNone" 
                                    onClick={onWorkkardClick}
                                    >{workkardDetail.WorkkardNumber}</button>
                                </div>
                                <div className="close">
                                    <button className="btn-cc__transparent" type="button" onClick={() => onPannelCloseClick('createNote')}><Icon name="close" className="icon" /></button>
                                </div>
                            </div>
                        </div>

                        <div className="noteSelect noteType colFlex">
                            <div className="rowFlex alignMiddle">
                                <label>Note Type</label>
                                <select id="noteSelectNoteTypeChange" className="wth-5 ml" value={enrichCreateNote?.noteData?.id ?? ""} onChange={(e) => onNoteTypeChange(e, state.selectedNoteTypeId)}>
                                    {noteTemplateOptions.map((item, key) => (
                                        (enrichCreateNote.templateType === CharConstants.Activity) ? (
                                            <option key={key} value={item.Id}>{item.NoteTemplateName}</option>
                                        ) : (
                                            (enrichCreateNote.templateType === CharConstants.Workkard) &&
                                            <option key={key} value={item.Id}>{item.NoteTemplateName}</option>
                                        )
                                    ))}
                                </select>
                            </div>
                            {
                                enrichCreateNote?.noteData?.description &&
                                <div className="info_txt toast toastList errorToast">
                                    <Icon name="warningMessage" className="icon mr" />
                                    {enrichCreateNote?.noteData?.description}
                                </div>
                            }
                        </div>

                        <div className={enrichCreateNote?.noteData?.description ? "scrollArea scrollError" : "scrollArea"} id="customFieldHolder">
                            <div className="editorContainer">
                                {state.displayTextEditor &&
                                    <CKTextEditor
                                        editorData={editorContentRef.current}
                                        className="ckTextEditor"
                                        onChange={editorChangeHandler}
                                    />
                                }
                                {state.displayEditorError &&
                                    <div className="errorMsg"><span id="errorBlockOfRichText" className="errorSelfMsg">{state.displayEditorError}</span></div>
                                }
                            </div>

                            <div className="mt notesFields">
                                {bindCustomFields()}
                            </div>

                            <div className="attachFileContainer mt__1">
                                <PublicApiExzeoUpload
                                    ref={(item) => (fileUploaderRef.current = item)}
                                    url={FILE_UPLOAD_URL}
                                    saveAndUpdateFileCaption={onsaveAndUpdateFileCaption}
                                    maxSize={MAX_UPLOAD_FILE_SIZE}
                                    inValidFiles={INVALID_FILES_TO_UPLOAD}
                                    multiple={true}
                                    openAttachedWorkardFiles={openAttachedWorkardFiles}
                                    uploadedData={state.notesUploadedFiles}
                                    onRemoveFile={handleNoteUploadFiles}
                                    removing={state.fileRemoving}
                                    setFalseRemovingState={setFalseRemovingState}
                                />
                            </div>

                            <div className="modalFooter">
                                <div className="rowFlex alignMiddle rowSpaceBetween">
                                    <div className="required alignMiddle">
                                        {publicApiPostError.note &&
                                            <>
                                                <Icon name="info" className="icon mr greyInfoIcon" /> {publicApiPostError.note}
                                            </>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="bottomContainer">
                            <button type="button" className="btn-cc__link btn-cc__link__blue" onClick={() => onPannelCloseClick('discardNote')}>
                                Discard
                            </button>
                            <div className="flex">
                                {renderPublishButtons()}
                            </div>
                        </div>
                    </div>
                </DropZone>
            }
        </div>
    );
};

const mapStateToProps = (state) => ({
    buttonLoading: state.workkardDetail.buttonLoaders.publishNote,
    publicApiPostError: state.workkardDetail.middlePanel.publicApiPostError
});

const mapDispatchToProps = (dispatch) => ({     
    showDialogueBox: bindActionCreators(showDialogueBox, dispatch),
    hideDialogueBox: bindActionCreators(hideDialogueBox, dispatch),
    saveAndUpdateFileCaption: bindActionCreators(saveAndUpdateFileCaption, dispatch),
    resetAttachedWorkkardFiles: bindActionCreators(resetAttachedWorkkardFiles, dispatch),
    resetAttachedWorkkardLetters: bindActionCreators(resetAttachedWorkkardLetters, dispatch),
    setPanelVisibility: bindActionCreators(setPanelVisibility, dispatch),
    hideRightPopUpBox: bindActionCreators(hideRightPopUpBox, dispatch),
    getTimezoneByZip: bindActionCreators(getTimezoneByZip, dispatch),
    resetPostApiActionError: bindActionCreators(resetPostApiActionError, dispatch)
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(NotePanelContainer);